'use strict'

import http from './http-common'
import authHeader from './auth-header'
import useSWR from 'swr'

const getAll = (companyId) => {
  return http.axiosClient.get(`/customers?companyId=${companyId}`, { headers: authHeader() })
}

const get = (id) => {
  return http.axiosClient.get(`/customers/${id}`, { headers: authHeader() })
}

const getWithOrders = (id) => {
  return http.axiosClient.get(`/customers/${id}?include[]=order`, { headers: authHeader() })
}

const create = (data) => {
  return http.axiosClient.post('/customers', data, { headers: authHeader() })
}

const update = (id, data) => {
  return http.axiosClient.put(`/customers/${id}`, data, { headers: authHeader() })
}

const remove = (id) => {
  return http.axiosClient.delete(`/customers/${id}`, { headers: authHeader() })
}

const findByName = (name, companyId) => {
  return http.axiosClient.get(`/customers?companyId=${companyId}&name=${name}`, { headers: authHeader() })
}

export default {
  getAll,
  get,
  getWithOrders,
  create,
  update,
  remove,
  findByName
}
